import { TOKEN_KEY } from "@app/store/authSlice";

export const getAccessToken = () => {
    if (typeof window === "undefined") {
        return "";
    }
    const token = localStorage.getItem(TOKEN_KEY);
    return token || "";
};